// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GNB (Global Navigation Bar) 스타일 */
.gnb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  gap: 2rem;
}

.gnb-brand h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* GNB 메뉴 스타일 */
.gnb-menu {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex: 1 1;
  justify-content: center;
}

.gnb-menu-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
}

.gnb-menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.gnb-menu-item:hover::before {
  left: 100%;
}

.gnb-menu-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.gnb-menu-item.active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.gnb-menu-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 2px;
  background: currentColor;
  border-radius: 1px;
}

.gnb-menu-item .menu-icon {
  font-size: 1rem;
  line-height: 1;
}

.gnb-menu-item .menu-label {
  white-space: nowrap;
}

.gnb-user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: nowrap;
}

.user-welcome {
  font-weight: 500;
  font-size: 0.95rem;
  white-space: nowrap;
}

.session-label {
  font-size: 0.85rem;
  opacity: 0.9;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.session-time {
  font-weight: 600;
  font-family: 'Courier New', monospace;
  color: #ffeb3b;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.extend-session-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 15px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.extend-session-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
}

.extend-session-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 세션 팝업 스타일 */
.session-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(5px);
}

.session-popup {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: popupSlideIn 0.3s ease-out;
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.session-popup-header h3 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.2rem;
  text-align: center;
}

.session-popup-content {
  margin-bottom: 1.5rem;
  text-align: center;
}

.session-popup-content p {
  margin: 0.5rem 0;
  color: #666;
  line-height: 1.5;
}

.session-popup-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.session-extend-btn {
  background: #4caf50;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.session-extend-btn:hover:not(:disabled) {
  background: #45a049;
}

.session-extend-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.session-logout-btn {
  background: #f44336;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.session-logout-btn:hover {
  background: #da190b;
}

/* 메뉴 버튼 색상 스타일 */
.gnb-menu-item.btn-success {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  color: white;
  border-color: #28a745;
}

.gnb-menu-item.btn-success:hover {
  background: linear-gradient(135deg, #1e7e34, #155724);
  border-color: #1e7e34;
}

.gnb-menu-item.btn-success.active {
  background: linear-gradient(135deg, #1e7e34, #155724);
  border-color: #155724;
}

.gnb-menu-item.btn-info {
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border-color: #17a2b8;
}

.gnb-menu-item.btn-info:hover {
  background: linear-gradient(135deg, #138496, #117a8b);
  border-color: #138496;
}

.gnb-menu-item.btn-info.active {
  background: linear-gradient(135deg, #138496, #117a8b);
  border-color: #117a8b;
}

.gnb-menu-item.btn-primary {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border-color: #007bff;
}

.gnb-menu-item.btn-primary:hover {
  background: linear-gradient(135deg, #0056b3, #004085);
  border-color: #0056b3;
}

.gnb-menu-item.btn-primary.active {
  background: linear-gradient(135deg, #0056b3, #004085);
  border-color: #004085;
}

.gnb-menu-item.btn-warning {
  background: linear-gradient(135deg, #ffc107, #e0a800);
  color: #212529;
  border-color: #ffc107;
}

.gnb-menu-item.btn-warning:hover {
  background: linear-gradient(135deg, #e0a800, #d39e00);
  border-color: #e0a800;
}

.gnb-menu-item.btn-warning.active {
  background: linear-gradient(135deg, #e0a800, #d39e00);
  border-color: #d39e00;
}

.gnb-menu-item.btn-secondary {
  background: linear-gradient(135deg, #6c757d, #5a6268);
  color: white;
  border-color: #6c757d;
}

.gnb-menu-item.btn-secondary:hover {
  background: linear-gradient(135deg, #5a6268, #495057);
  border-color: #5a6268;
}

.gnb-menu-item.btn-secondary.active {
  background: linear-gradient(135deg, #5a6268, #495057);
  border-color: #495057;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .gnb {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }
  
  .gnb-brand h1 {
    font-size: 1.25rem;
  }
  
  .gnb-menu {
    gap: 0.5rem;
    justify-content: center;
  }
  
  .gnb-menu-item {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
  
  .gnb-menu-item .menu-label {
    display: none; /* 모바일에서는 아이콘만 표시 */
  }
  
  .gnb-menu-item {
    min-width: 40px;
    justify-content: center;
  }
  
  .gnb-user-info {
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  
  .user-welcome {
    font-size: 0.85rem;
  }
  
  /* 길이(가로폭) 변동 방지: min-width와 text-align 추가 */
  .session-label,
  .session-time {
    font-size: 0.75rem;
    padding: 0.2rem 0.4rem;
    min-width: 60px;
    text-align: center;
    box-sizing: border-box;
    /* 필요시 width: 60px; 등으로 고정폭 지정 가능 */
  }
  
  .session-popup {
    margin: 1rem;
    padding: 1.5rem;
  }
  
  .session-popup-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .gnb-menu-item {
    padding: 0.35rem 0.6rem;
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GNB.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,4CAA4C;EAC5C;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;EACrC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF","sourcesContent":["/* GNB (Global Navigation Bar) 스타일 */\r\n.gnb {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem 2rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n  gap: 2rem;\r\n}\r\n\r\n.gnb-brand h1 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* GNB 메뉴 스타일 */\r\n.gnb-menu {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  align-items: center;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.gnb-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n  border: 1px solid transparent;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.gnb-menu-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.gnb-menu-item:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.gnb-menu-item:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.gnb-menu-item.active {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.gnb-menu-item.active::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -1px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 80%;\r\n  height: 2px;\r\n  background: currentColor;\r\n  border-radius: 1px;\r\n}\r\n\r\n.gnb-menu-item .menu-icon {\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.gnb-menu-item .menu-label {\r\n  white-space: nowrap;\r\n}\r\n\r\n.gnb-user-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.user-welcome {\r\n  font-weight: 500;\r\n  font-size: 0.95rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.session-label {\r\n  font-size: 0.85rem;\r\n  opacity: 0.9;\r\n  white-space: nowrap;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 12px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.session-time {\r\n  font-weight: 600;\r\n  font-family: 'Courier New', monospace;\r\n  color: #ffeb3b;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n  white-space: nowrap;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 12px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.extend-session-btn {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  color: white;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 15px;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.extend-session-btn:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.extend-session-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* 세션 팝업 스타일 */\r\n.session-popup-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.session-popup {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\r\n  animation: popupSlideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes popupSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px) scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.session-popup-header h3 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1.2rem;\r\n  text-align: center;\r\n}\r\n\r\n.session-popup-content {\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.session-popup-content p {\r\n  margin: 0.5rem 0;\r\n  color: #666;\r\n  line-height: 1.5;\r\n}\r\n\r\n.session-popup-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n}\r\n\r\n.session-extend-btn {\r\n  background: #4caf50;\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.session-extend-btn:hover:not(:disabled) {\r\n  background: #45a049;\r\n}\r\n\r\n.session-extend-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.session-logout-btn {\r\n  background: #f44336;\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.session-logout-btn:hover {\r\n  background: #da190b;\r\n}\r\n\r\n/* 메뉴 버튼 색상 스타일 */\r\n.gnb-menu-item.btn-success {\r\n  background: linear-gradient(135deg, #28a745, #1e7e34);\r\n  color: white;\r\n  border-color: #28a745;\r\n}\r\n\r\n.gnb-menu-item.btn-success:hover {\r\n  background: linear-gradient(135deg, #1e7e34, #155724);\r\n  border-color: #1e7e34;\r\n}\r\n\r\n.gnb-menu-item.btn-success.active {\r\n  background: linear-gradient(135deg, #1e7e34, #155724);\r\n  border-color: #155724;\r\n}\r\n\r\n.gnb-menu-item.btn-info {\r\n  background: linear-gradient(135deg, #17a2b8, #138496);\r\n  color: white;\r\n  border-color: #17a2b8;\r\n}\r\n\r\n.gnb-menu-item.btn-info:hover {\r\n  background: linear-gradient(135deg, #138496, #117a8b);\r\n  border-color: #138496;\r\n}\r\n\r\n.gnb-menu-item.btn-info.active {\r\n  background: linear-gradient(135deg, #138496, #117a8b);\r\n  border-color: #117a8b;\r\n}\r\n\r\n.gnb-menu-item.btn-primary {\r\n  background: linear-gradient(135deg, #007bff, #0056b3);\r\n  color: white;\r\n  border-color: #007bff;\r\n}\r\n\r\n.gnb-menu-item.btn-primary:hover {\r\n  background: linear-gradient(135deg, #0056b3, #004085);\r\n  border-color: #0056b3;\r\n}\r\n\r\n.gnb-menu-item.btn-primary.active {\r\n  background: linear-gradient(135deg, #0056b3, #004085);\r\n  border-color: #004085;\r\n}\r\n\r\n.gnb-menu-item.btn-warning {\r\n  background: linear-gradient(135deg, #ffc107, #e0a800);\r\n  color: #212529;\r\n  border-color: #ffc107;\r\n}\r\n\r\n.gnb-menu-item.btn-warning:hover {\r\n  background: linear-gradient(135deg, #e0a800, #d39e00);\r\n  border-color: #e0a800;\r\n}\r\n\r\n.gnb-menu-item.btn-warning.active {\r\n  background: linear-gradient(135deg, #e0a800, #d39e00);\r\n  border-color: #d39e00;\r\n}\r\n\r\n.gnb-menu-item.btn-secondary {\r\n  background: linear-gradient(135deg, #6c757d, #5a6268);\r\n  color: white;\r\n  border-color: #6c757d;\r\n}\r\n\r\n.gnb-menu-item.btn-secondary:hover {\r\n  background: linear-gradient(135deg, #5a6268, #495057);\r\n  border-color: #5a6268;\r\n}\r\n\r\n.gnb-menu-item.btn-secondary.active {\r\n  background: linear-gradient(135deg, #5a6268, #495057);\r\n  border-color: #495057;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n  .gnb {\r\n    padding: 1rem;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .gnb-brand h1 {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .gnb-menu {\r\n    gap: 0.5rem;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .gnb-menu-item {\r\n    padding: 0.4rem 0.8rem;\r\n    font-size: 0.85rem;\r\n  }\r\n  \r\n  .gnb-menu-item .menu-label {\r\n    display: none; /* 모바일에서는 아이콘만 표시 */\r\n  }\r\n  \r\n  .gnb-menu-item {\r\n    min-width: 40px;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .gnb-user-info {\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .user-welcome {\r\n    font-size: 0.85rem;\r\n  }\r\n  \r\n  /* 길이(가로폭) 변동 방지: min-width와 text-align 추가 */\r\n  .session-label,\r\n  .session-time {\r\n    font-size: 0.75rem;\r\n    padding: 0.2rem 0.4rem;\r\n    min-width: 60px;\r\n    text-align: center;\r\n    box-sizing: border-box;\r\n    /* 필요시 width: 60px; 등으로 고정폭 지정 가능 */\r\n  }\r\n  \r\n  .session-popup {\r\n    margin: 1rem;\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .session-popup-actions {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .gnb-menu-item {\r\n    padding: 0.35rem 0.6rem;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
